exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-mobile-error[data-v-49510d96]{height:100%;display:flex;align-items:center;justify-content:center;text-align:center}.fts-mobile-error .mobile-error-title[data-v-49510d96]{font-weight:500;font-size:1.25rem;line-height:1.75rem}.fts-mobile-error .mobile-error-description[data-v-49510d96]{margin-top:.5rem;font-size:.875rem;line-height:1.25rem;color:var(--fts-default);white-space:break-spaces}", ""]);

// exports
